import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  public _ = _;
  public name: string;
  public verifactu: boolean;
  public year: number = moment().year();

  constructor(
    private cookieService: CookieService,
    public router: Router,
  ){}

  ngOnInit(): void {
    this.name = this.cookieService.get('footerName');
  }

  public goVerifactu(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([this.cookieService.get('urlTenant') || 'benefit', 'billing', 'verifactu'])
    );
    window.open(url, '_blank');
  }
}
